import { render, staticRenderFns } from "./simpleList_wAdd.vue?vue&type=template&id=4c70435e&scoped=true&"
import script from "./simpleList_wAdd.vue?vue&type=script&lang=js&"
export * from "./simpleList_wAdd.vue?vue&type=script&lang=js&"
import style0 from "./simpleList_wAdd.vue?vue&type=style&index=0&id=4c70435e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c70435e",
  null
  
)

export default component.exports